import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const PlusIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 4V16M4 10H16"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);
export { PlusIcon };
